import { useState } from 'react';
import PropTypes from 'prop-types';

import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { productPayment } from 'store/treasury-actions';

import classes from './RowMenu.module.css';

const RowMenu = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [paymentDeyails, setPaymentDetails] = useState({});
  console.log(
    '🚀 ~ file: RowMenu.js:16 ~ RowMenu ~ paymentDeyails:',
    paymentDeyails
  );

  const open = Boolean(anchorEl);

  const openMenuHandler = event => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenuHandler = () => {
    setAnchorEl(false);
  };

  const showDetailsHandler = id => () => {
    (async () => {
      setPaymentDetails(await productPayment(id));
    })();
    setAnchorEl(false);
  };

  return (
    <>
      <IconButton
        onClick={openMenuHandler}
        className={classes.moreBtn}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        classes={{ paper: classes.menuContainer }}
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenuHandler}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem
          className={classes.menuItem}
          href={props.urlProduct}
          component="a"
        >
          Ir al artículo comprado
        </MenuItem>
        {props.isBilling == 1 && (
          <MenuItem
            // onClick={billRequest(props.idUserPayment)}
            className={classes.item}
            disabled={props.send === 1}
          >
            {props.send === 1
              ? 'Factura solicitada'
              : 'Solicitar factura'}
          </MenuItem>
        )}
        <MenuItem
          className={classes.menuItem}
          onClick={showDetailsHandler(props.idUserPayment)}
        >
          Ver datos de mi pago
        </MenuItem>
      </Menu>
    </>
  );
};

RowMenu.propTypes = {
  // eslint-disable-next-line react/require-default-props
  isBilling: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  urlProduct: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  idUserPayment: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  send: PropTypes.number
};

export default RowMenu;
